riot.tag2('channel-select', '<div class="ui fluid selection dropdown channel"> <input name="channel" type="hidden" onchange="{channelSelect}"> <i class="dropdown icon"></i> <div class="default text">Channel auswählen</div> <div class="menu"> <div each="{name, channel in opts.channels}" class="item" data-value="{name}"> <img class="ui mini avatar image" riot-src="{channel.image}"> {channel.name} </div> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var radio = opts.radio;

this.channelSelect = function (e) {
    var value = _this.channel.value;
    if (!value) {
        $('#ChannelInfo').modal('setting', 'closable', false).modal('show');
    } else {
        radio.switch(opts.channels[value], "lq");
    }
};

this.on('mount', function () {
    $('.ui.dropdown.channel').dropdown({
        action: 'activate',
        onChange: function onChange(value, text, $selectedItem) {}
    });
});
});



// WEBPACK FOOTER //
// ./src/js/elements/channelselect.tag